import ClaimCode from "./ClaimCode";

export default ClaimCode